import { z } from "zod";

export const BUYER_GUIDES_REQUEST_CASE_VIEW_MODEL_SCHEMA = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().min(1, "Email is required"),
  breed: z.string().optional(),
});

export type BuyerGuidesRequestCaseViewModel = z.infer<
  typeof BUYER_GUIDES_REQUEST_CASE_VIEW_MODEL_SCHEMA
>;
